import { Navigate } from 'react-router-dom';
import { useOrganization, useOrganizationList } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';
import {
  getPostAuthOrgPath,
  usePrivilegedStaffBypass,
} from '@/hooks/use-privileged-staff-bypass';

/**
 * Redirect component for legacy /setup-payment route
 * Redirects to /org/{slug}/setup-payment for the current/first org
 */
export function SetupPaymentRedirect() {
  const { organization, isLoaded: orgLoaded } = useOrganization();
  const { userMemberships, isLoaded: membershipsLoaded } = useOrganizationList({
    userMemberships: {
      pageSize: 1,
    },
  });
  const { canBypass, isLoaded: claimsLoaded } = usePrivilegedStaffBypass();

  if (!orgLoaded || !membershipsLoaded || !claimsLoaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <Loader2 className="text-muted-foreground mx-auto h-8 w-8 animate-spin" />
          <p className="text-muted-foreground mt-4 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Get org slug
  const orgSlug = organization?.slug || userMemberships?.data?.[0]?.organization?.slug;

  if (!orgSlug) {
    // No org found, redirect to no-organization page
    return <Navigate to="/no-organization" replace />;
  }

  return <Navigate to={getPostAuthOrgPath(orgSlug, canBypass)} replace />;
}

